const newModel = () => {
    return {
        loaiTrudenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        loaiTrudenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        loaiTrudenId: item.loaiTrudenId,
        ten: item.ten,
        chieuSang: item.chieuSang,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        loaiTrudenId: item.loaiTrudenId,
        ten: item.ten,
        chieuSang: item.chieuSang,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        loaiTrudenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        loaiTrudenId: item.loaiTrudenId,
        ten: item.ten,
        chieuSang: item.chieuSang,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}


const errors = () => {
    return {
        loaiTrudenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const loaiTruDenModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


